

const ListRecipientOptOutsItemSchema = {
  email: { format: 'email' },
  createdAt: { format: 'date-time' },
  updatedAt: { format: 'date-time' }
}

export default ListRecipientOptOutsItemSchema
